export var getPersiana = function getPersiana(state) {
  return state.persiana;
};
export var getActiva = function getActiva(state) {
  return getPersiana(state).activa;
};
export var getVisible = function getVisible(state) {
  return getPersiana(state).visible;
};
export var getPosicion = function getPosicion(state) {
  return getPersiana(state).posicion;
};